<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <!-- <a-col :span="24">
              <a-form-model-item label="评价来源" prop="commentsSource">
                <a-select v-model="model.commentsSource" placeholder="请选择评价来源">
                  <a-select-option :value="0">PC</a-select-option>
                  <a-select-option :value="1">H5</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col> -->
            <a-col :span="24">
              <a-form-model-item :label="$t('满意度')" prop="commentsLevel">
                <a-rate v-model="model.commentsLevel" :tooltips="satisfactionLevels" />
                <span class="ant-rate-text">{{ satisfactionLevels[model.commentsLevel - 1] }}</span>
              </a-form-model-item>
            </a-col>
            <a-divider orientation="left">{{ $t('工单类型分类评价') }}</a-divider>
            <a-col :span="6" v-for="item in commentsTypeList">
              <a-form-model-item label="" prop="">
                <!-- {{item.label}}：
                <a-rate v-model="item.commentsLevel" :tooltips="['非常不满意','不满意','一般','满意','非常满意']" />
                <span class="ant-rate-text">{{ ['非常不满意','不满意','一般','满意','非常满意'][item.commentsLevel - 1] }}</span> -->
                <el-checkbox v-model="item.checked">{{item.label}}</el-checkbox>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('评论信息')" prop="commentsInformation">
                <a-textarea v-model="model.commentsInformation" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {
    filterDictTextByCache,
    initDictOptions,
    getDictItems
  } from '@/components/dict/JDictSelectUtil';
  export default {
    name: 'WorkOrderEvaluationModal',
    components: {},
    data() {
      let validateRemark = (rule, value, callback) => {
        if(this.model.audit == 0){
          if(value){
            callback();
          }else{
            callback(new Error(this.$t('请输入备注')));
          }
        }else{
          callback();
        }
      };
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-engineering/ticket/ticketsComments/add",
          queryByTicketsId: "/jeecg-engineering/ticket/ticketsComments/queryByTicketsId",
        },
        commentsTypeList: []
      }
    },
    computed: {
      validatorRules() {
        return {
          commentsLevel:{ required: true,message: this.$t('请选择满意度'), trigger: 'change' },
        }
      },
      satisfactionLevels() {
        return ['非常不满意','不满意','一般','满意','非常满意'].map(v => this.$t(v))
      },
    },
    watch:{},
    methods: {
      getUserList(){},
      init(row,type){
        let that = this;
        this.visible = true;
        if(type == 'add'){
          this.title = this.$t('评价');
          this.disableSubmit = false;
          this.model = {};
          this.model.ticketsId = row.id;
          this.model.ticketsNum = row.ticketsNum;
          this.model.commentsSource = 0;
          if(row.ticketsType == 0){
            initDictOptions('commentsMeterType').then(res=>{
              this.commentsTypeList = res.result;
            });
          }else if(row.ticketsType == 1){
            initDictOptions('commentsReportType').then(res=>{
              this.commentsTypeList = res.result;
            });
          }else{
            initDictOptions('commentsRepairType').then(res=>{
              this.commentsTypeList = res.result;
            });
          }
        }else{
          this.title = this.$t('查看评价');
          this.disableSubmit = true;
          this.commentsTypeList = [];
          getAction(this.url.queryByTicketsId,{ticketsId: row.id}).then(res=>{
            if(res.success){
              that.model = Object.assign({},res.result);
              let typeObj = JSON.parse(res.result.commentsType);
              for(let key in typeObj){
                that.commentsTypeList.push({
                  label: key,
                  checked: typeObj[key]
                });
              }
            }
          })
        }
      },
      handleCancel() {
        this.visible = false;
      },
      handleOk() {debugger
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let params = {}
            params = Object.assign({},that.model);
            params.commentsType = {}
            that.commentsTypeList.map(c=>{
              that.$set(params.commentsType,c.label,c.checked);
            });
            params.commentsType = JSON.stringify(params.commentsType);
            postAction(this.url.add,params).then((res) => {
              if (res.success) {
                that.$message.success(this.$t('操作成功'));
                that.$emit('ok');
                this.visible = false;
                that.confirmLoading = false;
              } else {
                that.$message.warning(res.message);
              }
            })
            // .finally(() => {
            //   that.confirmLoading = false;
            // })
          }

        })
      },
    }
  }
</script>